import api from '../utils/api';

export interface UserProfile {
  userId: number;
  username: string;
  fullName: string;
  email: string;
  phone: string;
  address: string;
  avatar: string;
  roleName: string;
  createdAt: string;
  lastLogin: string;
  isActive: boolean;
}

export interface ChangePasswordData {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export interface UpdateProfileData {
  fullName: string;
  email: string;
  phone?: string;
  address?: string;
}

export class ProfileService {
  /**
   * Lấy thông tin hồ sơ cá nhân
   */
  static async getProfile(): Promise<UserProfile> {
    try {
  const response = await api.get('/api/v1/profile');
      return response.data.data || response.data;
    } catch (error) {
      console.error('Error fetching profile:', error);
      throw error;
    }
  }

  /**
   * Cập nhật thông tin hồ sơ cá nhân
   */
  static async updateProfile(data: UpdateProfileData): Promise<UserProfile> {
    try {
  const response = await api.put('/api/v1/profile', data);
      return response.data.data || response.data;
    } catch (error) {
      console.error('Error updating profile:', error);
      throw error;
    }
  }

  /**
   * Đổi mật khẩu
   */
  static async changePassword(data: ChangePasswordData): Promise<void> {
    try {
  await api.post('/api/v1/profile/change-password', data);
    } catch (error) {
      console.error('Error changing password:', error);
      throw error;
    }
  }

  /**
   * Upload ảnh đại diện
   */
  static async uploadAvatar(file: File): Promise<UserProfile> {
    try {
      const formData = new FormData();
      formData.append('avatar', file);
      
  const response = await api.post('/api/v1/profile/upload-avatar', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      return response.data.data || response.data;
    } catch (error) {
      console.error('Error uploading avatar:', error);
      throw error;
    }
  }

  /**
   * Xóa ảnh đại diện
   */
  static async removeAvatar(): Promise<UserProfile> {
    try {
  const response = await api.delete('/api/v1/profile/avatar');
      return response.data.data || response.data;
    } catch (error) {
      console.error('Error removing avatar:', error);
      throw error;
    }
  }

  /**
   * Lấy lịch sử đăng nhập
   */
  static async getLoginHistory(): Promise<any[]> {
    try {
  const response = await api.get('/api/v1/profile/login-history');
      return response.data;
    } catch (error) {
      console.error('Error fetching login history:', error);
      throw error;
    }
  }

  /**
   * Lấy danh sách phiên đăng nhập hiện tại
   */
  static async getActiveSessions(): Promise<any[]> {
    try {
  const response = await api.get('/api/v1/profile/active-sessions');
      return response.data;
    } catch (error) {
      console.error('Error fetching active sessions:', error);
      throw error;
    }
  }

  /**
   * Đăng xuất từ tất cả thiết bị
   */
  static async logoutAllDevices(): Promise<void> {
    try {
  await api.post('/api/v1/profile/logout-all-devices');
    } catch (error) {
      console.error('Error logging out all devices:', error);
      throw error;
    }
  }
}

export default ProfileService;
